export const REFRESH_CATEGORIES = 'REFRESH_CATEGORIES';
